import React from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../services/L10n';
import { previousView } from '../../state/navigation';
import StopPropagation from '../utils/StopPropagation';
import { KompisPrompt } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { actionCloseDialog } from '../../state/dialog/dialogActions';
import { actionSetOverlayState } from '../../state/popups/popupsActions';
import { t } from '../../translations';

const PacMissing = () => {
  const dispatch = useDispatch();

  /**
   * Close modal and navigate to start view
   */
  const close = (): void => {
    dispatch(actionCloseDialog());
    dispatch(previousView());
    dispatch(actionSetOverlayState(false));
  };

  return (
    <StopPropagation>
      <KompisPrompt
        heading={translate(t.INVALID_CONFIGURATION_MESSAGE)}
        visible={true}
        disableIframeSticky={true}
        theme={SkapaTheme}
        primaryButtonLabel={translate(t.INVALID_CONFIGURATION_DESCRIPTION)}
        onButtonClick={close}
      ></KompisPrompt>
    </StopPropagation>
  );
};

export default PacMissing;
